<template>
  <!-- 添加点卷弹窗 -->
  <van-popup v-model="showPopup" class="transparent-popup" position="bottom">
    <div class="v-pop-add">
      <div class="btn-close" @click="close"></div>
      <div class="content">
        <div class="title">buff券数量</div>
        <div class="nbox">
          <div class="s"></div>
          <div class="t">{{ superInfo.userInfo.myRemainingTicketCount }}</div>
        </div>
        <div class="list">
          <div class="item" @click="handleJoin(1)">加1张</div>
          <div class="item" @click="handleJoin(5)">加5张</div>
          <div class="item" @click="handleJoin(10)">加10张</div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { mapState } from "vuex";
import { Popup as VanPopup } from "vant";

export default {
  name: "VPopImg",

  components: {
    VanPopup,
  },

  props: {
    superInfo: {
      type: Object,
      default: () => {},
    },
  },

  watch: {
    superInfo: {
      immediate: true,
      handler(newVal) {
        this.info = newVal;
      },
    },
  },

  data() {
    return {
      // 报名信息
      info: this.superInfo,
      // 展示弹窗
      showPopup: false,
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  mounted() {},

  methods: {
    // 显示弹窗
    open() {
      this.showPopup = true;
    },
    // 关闭弹窗
    close() {
      this.showPopup = false;
    },

    handleJoin(count) {
      this.$emit("success", count);
    },
  },
};
</script>

<style lang="less">
// 弹窗背景透明
.transparent-popup {
  background-color: transparent !important;
}
//  图片弹窗
.v-pop-add {
  position: relative;
  width: 100%;
  .btn-close {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 22px;
    height: 22px;
    background-image: url("../assets/image/icon-pop-close.png");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center top;
  }
  .content {
    padding: 20px 20px 50px;
    border-radius: 35px 35px 0 0;
    font-size: 14px;
    font-weight: 400;
    background: #fff;
    text-align: center;
    background-image: url("../assets/image/bg-pop-add.png");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center top;
    .title {
      margin-bottom: 20px;
      color: #001a33;
      font-size: 20px;
      font-weight: 600;
    }
    .nbox {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: 36px;
      padding: 0 20px;
      margin: 0 auto 30px;
      border-radius: 18px;
      .s {
        width: 32px;
        height: 28px;
        margin-right: 5px;
        background-image: url("../assets/image/icon-num.png");
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: center top;
      }
      .t {
        font-weight: 600;
        font-size: 24.5px;
        color: #001a33;
      }
    }
    .list {
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 100%;
      .item {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100px;
        height: 45px;
        font-weight: 500;
        font-size: 16px;
        color: #001a33;
        background-image: url("../assets/image/btn-add.png");
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: center top;
      }
    }
  }
}
</style>
